export default __webpack_public_path__ + "static/media/portfolio-cerini-1.9d1c0387.jpg";